import _ from 'lodash'

export const icon = 'books'
export const humanName = {
  singular: 'Convites',
  plural: 'Convites'
}
export const getConfig = props => {
  const { digitalProductId } = props
  const basePath = '/convites'
  const apiBasePath = '/public/gamification_invites'
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]
  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    getBreadcrumbs
  }

  return config
}
